import gallery1Img from "../assets/images/gallery-images/Impact_story_photo_MamaLink.jpg";
import gallery2Img from "../assets/images/gallery-images/story-gallery-img2.jpg";
import S3CLink from "../components/S3CLink";

const galleryList = [
  {
    id: 0,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: MamaLink staff training emergency personnel in Siaya County </span> 
        <strong className='gallery-coalition-title'>A Swift Response</strong>
        A swift emergency response successfully saved an expectant mother and her baby on Mageta Island, Siaya County. At 3:52 am, a distress call alerted responders to a high-risk labor case requiring immediate transfer to Bondo Sub-County Hospital, 28.7 km away. Due to the remote location, a complex transfer involving both boat and ambulance was necessary. A local boat transported the mother across Lake Victoria to Usenge Beach, where a Prodigy Ambulance crew completed the 29.3 km journey by road. At the hospital, a prepared medical team performed a life-saving emergency C-section. Follow-up confirmed both mother and baby were healthy.
      </p>
    ),
    image: gallery1Img
  },
  {
    id: 1,
    caption: (
      <p>
        <span className='gallery-caption'>Photo: Workers at the ambulance dispatch centre</span> 
        <strong className='gallery-coalition-title'>Robust Referral Services Save Lives</strong>
        Workers at the dispatch centre received a call pleading for urgent help for a mother who had lost a previous pregnancy and was struggling with drug addiction. The baby was at risk of being born with complications. Within 7 minutes, an ambulance was on site. Fortunately, the mother delivered a healthy baby girl before being transported by the ambulance team. Both were transferred to a higher-level hospital for further review and monitoring. After a few days of care, both the baby and the mother were determined to be healthy and were discharged from the hospital.
      </p>
    ),
    image: gallery2Img
  }
];

export default galleryList;
